<div class="col-xs-12 col-md-12" style="padding: 40px 60px;">

  <h2 class="d-block d-sx-none d-sm-none" style="margin-bottom: 30px; font-size: 36px"><i
      class="fa fa-caret-right blue-font"></i> Select a project below to find out more:</h2>
  <h2 class="d-none d-xs-block d-sm-block" style="margin-bottom: 30px"><i class="fa fa-caret-right blue-font"></i>
    Select a
    project below to find out more:</h2>

  <div class="col-xs-12 no-padding ">
    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="environer" (click)="selectProject('environer')">
          <div style="height: 115px;">
            <img src="../../assets/images/env_logo.png"
              style="height: 80px; margin-top: 10px; background-color: #231f20;">
          </div>
          <img src="../../assets/images/environer.png" class="projectthumb">
        </a>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="atrium" (click)="selectProject('atrium')">
          <div style="height: 115px;">
            <img src="../../assets/images/ATRIUM_Logo.png" style="height: 80px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/atrium.png" class="projectthumb">
        </a>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="rdo" (click)="selectProject('rdo')">
          <div style="height: 115px;">
            <img src="../../assets/images/rdo_logo.png" style="height: 80px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/rdo.png" class="projectthumb">
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="pest" (click)="selectProject('pest')">
          <div style="height: 115px;">
            <img src="../../assets/images/pest-logo.jpg" style="height: 80px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/pest.png" class="projectthumb">
        </a>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ecohealth" (click)="selectProject('ecohealth')">
          <div style="height: 115px;">
            <img src="../../assets/images/ecohealth_logo.png" style="height: 80px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/ecohealth.png" class="projectthumb">
        </a>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ecohealth" (click)="selectProject('ecohealth')">
          <div style="height: 115px;">
            <img src="../../assets/images/ecohealth_logo.png" style="height: 80px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/ecohealth-hornsby.png" class="projectthumb">
        </a>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="worm" (click)="selectProject('worm')">
          <div style="height: 115px;">
            <img src="../../assets/images/worm-logo.png" style="height: 80px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/turned_worm.jpg" class="projectthumb">
        </a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="herbarium" (click)="selectProject('herbarium')">
          <div style="height: 115px;">
            <img src="../../assets/images/herb_logo.png" style="max-height: 80px; max-width: 90%; margin-top: 20px;">
          </div>
          <img src="../../assets/images/herbarium.jpg" class="projectthumb">
        </a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="enrichinglivestock" (click)="selectProject('enrichinglivestock')">
          <div style="height: 115px;">
            <img src="../../assets/images/eal_logo.jpg" style="height: 110px;">
          </div>
          <img src="../../assets/images/eal.jpg" class="projectthumb">
        </a>
      </div>

    </div>


    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="adri" (click)="selectProject('adri')">
          <div style="height: 115px;">
            <img src="../../assets/images/ADRI_Logo.png" style="height: 70px; margin-top: 35px;">
          </div>
          <img src="../../assets/images/ADRI.jpg" class="projectthumb">
        </a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ag360" (click)="selectProject('ag360')">
          <div style="height: 115px;">
            <img src="../../assets/images/Ag360_Logo.png" style="height: 75px; margin-top: 30px;">
          </div>
          <img src="../../assets/images/Ag360.jpg" class="projectthumb">
        </a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ag360education" (click)="selectProject('ag360education')">
          <div style="height: 115px;">
            <img src="../../assets/images/Ag_360_Education_Logo.png" style="height: 75px; margin-top: 30px;">
          </div>
          <img src="../../assets/images/ag360education.png" class="projectthumb">
        </a>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ramselect" (click)="selectProject('ramselect')">
          <div style="height: 115px;">
            <img src="../../assets/images/RamSelect_Logo.jpg" style="height: 55px; margin-top: 50px;">
          </div>
          <img src="../../assets/images/ramselect.jpg" class="projectthumb">
        </a>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ramselecttraining" (click)="selectProject('ramselecttraining')">
          <div style="height: 115px;">
            <img src="../../assets/images/RamSelect_Training_Logo.png" style="height: 55px; margin-top: 50px;">
          </div>
          <img src="../../assets/images/ramselecttraining.png" class="projectthumb">
        </a>
      </div>
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="sheepdna" (click)="selectProject('sheepdna')">
          <div style="height: 115px;">
            <img src="../../assets/images/sheepdna_logo.png" style="height: 50px; margin-top: 60px;">
          </div>
          <img src="../../assets/images/sheepdna.jpg" class="projectthumb" style="border: none;">
        </a>
      </div>

    </div>

    <div class="row">

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="ldlinsights" (click)="selectProject('ldlinsights')">
          <div style="height: 115px;">
            <img src="../../assets/images/ldl_logo.png" style="height: 90px; margin-top: 10px;">
          </div>
          <img src="../../assets/images/ldl.jpg" class="projectthumb">
        </a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="sugarmaps" (click)="selectProject('sugarmaps')">
          <div style="height: 115px;">
            <img src="../../assets/images/sugarmaps_logo.png" style="height: 70px; margin-top: 30px;">
          </div>
          <img src="../../assets/images/sugarmaps.jpg" class="projectthumb" style="border: none;">
        </a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="mobselect" (click)="selectProject('mobselect')">
          <div style="height: 115px;">
            <img src="../../assets/images/mobselect_logo.png" style="height: 90px; margin-top: 15px;">
          </div>
          <img src="../../assets/images/mobselect.jpg" class="projectthumb" style="border: none;">
        </a>
      </div>

    </div>

    <div class="row">
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <div style="height: 115px;">
          <img src="../../assets/images/labreport_logo.png" style="margin-top: 20px; height: 80px;">
        </div>
        <a anchor-smooth-scroll="labreport" (click)="selectProject('labreport')">
          <img src="../../assets/images/labreport.jpg" class="projectthumb" style="border: 1px solid #ddd;"></a>
      </div>

      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="hens" (click)="selectProject('hens')">
          <div style="height: 115px;">
            <img src="../../assets/images/hens_logo.png" style="height: 90px; margin-top: 20px;">
          </div>
          <img src="../../assets/images/hens.jpg" class="projectthumb">
        </a>
      </div>
      <!-- <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a  anchor-smooth-scroll="askbill" ng-(click)="vm.selectProject('askbill')">
          <div style="height: 115px;">
            <img src="../../assets/images/AskBill_Logo.png" style="height: 45px; margin-top: 55px;">
          </div>
          <img src="../../assets/images/askbill.jpg" class="projectthumb">
        </a>
      </div> -->
      <div class="col-md-4 col-sm-6 col-xs-12" style="text-align: center;">
        <a anchor-smooth-scroll="lagoons" (click)="selectProject('lagoons')">
          <div style="height: 115px;">
            <img src="../../assets/images/lagoons_logo.png" style="height: 100px;">
          </div>
          <img src="../../assets/images/lagoons.jpg" class="projectthumb">
        </a>
      </div>



    </div>


  </div>

  <div class="bar-divider col-md-12 col-xs-12 col-sm-12" style="padding: 0px 60px"></div>

  @switch (selectedProject) {
  @case("atrium"){
  <div id="atrium" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <div id="chartbanner" style="max-width: 500px;">
          <div id="chartbanner-text">
            <img src="../../assets/images/piechart.png" style="width: 100%;">
          </div>
        </div>
        <!-- <img src="../../assets/images/atrium_img.png" style="width: 100%; max-width: 500px;"> -->
        <p class="largetext light-font">The Atrium project helps academics connect with their students to offer
          ongoing support through meaningful connections.</p>
        <p class="largetext light-font">
          Visit <a href="https://atrium.une.edu.au" target="_blank" class="altlink"> Atrium</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <div id="chartbanner-sm" style="max-width: 400px; min-width: 300px;">
          <div id="chartbanner-text">
            <img src="../../assets/images/piechart.png" style="width: 100%;">
          </div>
        </div>
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://atrium.une.edu.au" target="_blank">
            <img src="../../assets/images/ATRIUM_Logo.png" style="margin: 0px 0px 40px 0px; height: 110px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://atrium.une.edu.au" target="_blank">
            <img src="../../assets/images/ATRIUM_Logo.png" style="margin: 0px 0px 30px 0px; height: 110px;"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://atrium.une.edu.au" target="_blank">
            <img src="../../assets/images/ATRIUM_Logo.png" style="margin: 0px 0px 30px 0px; height: 90px;"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Multiple systems capturing a student’s learning journey</p>
        <p><b>How does Atrium address the problem?</b></p>
        <p>Atrium is built to integrate data from multiple systems allowing academics an easier way to view a
          student’s learning journey with the ability to contact their students and offer support through
          meaningful connection.</p>
        <p>Dashboards provide integrated student data; automatic alerts & multiple communication methods make it simple
          to
          contact students.</p>
        <p>The Knowledge Base provides a first stop for all UNE Academics when they need information about
          student-facing
          supports.</p>
        <p><b>How is data science applied?</b></p>
        <p>Simplifying access to all the information related to a student’s learning journey, facilitating greater
          connection to students for academics, simplifying engagement and improving retention</p>
        <br>
        <p>Atrium has been developed by CASI for the University of New England.</p>
      </div>

      <!-- <div class="col-xs-12" style="text-align: right;">
      <a  style="color: inherit;"><i class="fa fa-chevron-up fa-2x" ng-(click)="vm.backToTop()"></i></a>
      <hr style="border-top: 2px solid;">
    </div> -->

    </div>
  </div>
  }
  @case("rdo"){
  <div id="rdo" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/rdo_img.png" style="width: 100%; max-width: 270px;">
        <p class="largetext light-font">The Research Data Optimisation Tool (RDO) project helps UNE to understand
          our areas of research strength and emerging research areas.</p>
        <p class="largetext light-font">
          Visit <a href="https://resdataopt.une.edu.au" target="_blank" class="altlink"> RDO</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/rdo_img.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://resdataopt.une.edu.au" target="_blank">
            <img src="../../assets/images/rdo_logo.png" style="margin: 0px 0px 40px 0px; height: 110px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://resdataopt.une.edu.au" target="_blank">
            <img src="../../assets/images/rdo_logo.png" style="margin: 0px 0px 30px 0px; height: 110px;"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://resdataopt.une.edu.au" target="_blank">
            <img src="../../assets/images/rdo_logo.png" style="margin: 0px 0px 30px 0px; height: 90px;"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Manual system in place</p>
        <p><b>How does RDO address the problem?</b></p>
        <p>The Research Data Optimisation Tool (RDO) has been built to facilitate a central point of access to view
          the research Academics have been undertaking.</p>
        <p>This online tool provides visualisation of the areas of strength and areas requiring further development,
          to enhance our capacity to address the development of regional and world priorities.</p>
        <p><b>How is data science applied?</b></p>
        <p>RDO is a tool that provides online access to simplify the assignment of existing research outputs to an
          appropriate research discipline of Field of Research (FoR) as defined by the Australian Bureau of Statistics
          Australian and New Zealand Standard Research Classification (ANZSRC), allowing us to report and analyse
          the information for use in decision making processes.</p>
        <br>
        <p>RDO has been developed by CASI for the University of New England.</p>
      </div>

      <!-- <div class="col-xs-12" style="text-align: right;">
      <a  style="color: inherit;"><i class="fa fa-chevron-up fa-2x" ng-(click)="vm.backToTop()"></i></a>
      <hr style="border-top: 2px solid;">
    </div> -->

    </div>
  </div>
  }
  @case("pest"){
  <div id="pest" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/pest_img.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">The Practical Ecology, Science and Technology Research (PEST) project
          facilitates the upload of captured images to an online system for tagging requirements, removing the
          need for physical distribution of these image via external data sources.</p>
        <p class="largetext light-font">
          Visit <a href="https://pest.une.edu.au" target="_blank" class="altlink"> PEST</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/pest_img.png" style="width: 230px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://pest.une.edu.au" target="_blank">
            <img src="../../assets/images/pest-logo.jpg" style="margin: 0px 0px 40px 0px; height: 140px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://pest.une.edu.au" target="_blank">
            <img src="../../assets/images/pest-logo.jpg" style="margin: 0px 0px 30px 0px; height: 140px;"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://pest.une.edu.au" target="_blank">
            <img src="../../assets/images/pest-logo.jpg" style="margin: 0px 0px 30px 0px; height: 100px;"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Review & tagging of images involved the extensive distribution of physical portable external data sources to
          wildlife management professionals across Australia.</p>
        <p><b>How does PEST address the problem?</b></p>
        <p>PEST has 2 components to facilitate the sharing of data without the need to transport physical storage
          devices.
        </p>
        <p>The 1st component allows for the uploading of images directly into a repository that is accessible by all
          authorised users online.</p>
        <p>The 2nd component manages the online tool that allows for the tagging & approval of images uploaded by
          wildlife
          management professionals.</p>
        <p>Previous and current projects, the student work we're supporting, and our dedicated team members is available
          for view on the site.</p>
        <p><b>How is data science applied?</b></p>
        <p>The PEST service streamlines the image upload and handling of these images for tagging & approval
          requirements.
        </p>
        <br>
        <p>PEST has been developed by CASI for the University of New England.</p>
      </div>

      <!-- <div class="col-xs-12" style="text-align: right;">
      <a  style="color: inherit;"><i class="fa fa-chevron-up fa-2x" ng-(click)="vm.backToTop()"></i></a>
      <hr style="border-top: 2px solid;">
    </div> -->
    </div>
  </div>
  }
  @case("ecohealth"){
  <div id="ecohealth" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/eco_img.jpg" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">The Ecohealth project allows for a catchment-scale assessment of aquatic
          ecosystem
          health.</p>
        <p class="largetext light-font">
          Visit <a href="https://ecohealth.une.edu.au" target="_blank" class="altlink"> Ecohealth - Coffs Harbour</a>
        </p>
        <p class="largetext light-font">
          Visit <a href="https://waterwayhealth.hornsby.nsw.gov.au" target="_blank" class="altlink"> Ecohealth - Hornsby
            Council</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/eco_img.jpg" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://ecohealth.une.edu.au" target="_blank">
            <img src="../../assets/images/ecohealth_logo.png" style="margin: 0px 0px 40px 0px; height: 100px;">
          </a>
          <a href="https://waterwayhealth.hornsby.nsw.gov.au" target="_blank">
            <img src="../../assets/images/Hornsby.png" style="margin: 0px 0px 40px 40px; height: 100px;">
          </a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://ecohealth.une.edu.au" target="_blank">
            <img src="../../assets/images/ecohealth_logo.png" style="margin: 0px 0px 30px 0px; height: 100px;">
          </a>
          <a href="https://waterwayhealth.hornsby.nsw.gov.au" target="_blank">
            <img src="../../assets/images/Hornsby.png" style="margin: 0px 0px 30px 30px; height: 100px;">
          </a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://ecohealth.une.edu.au" target="_blank">
            <img src="../../assets/images/ecohealth_logo.png" style="margin: 0px 0px 30px 0px; height: 80px;">
          </a>
          <a href="https://waterwayhealth.hornsby.nsw.gov.au" target="_blank">
            <img src="../../assets/images/Hornsby.png" style="margin: 0px 0px 30px 0px; height: 80px;">
          </a>
        </div>
        <!-- <p><b>What was the industry problem?</b></p> -->
        <p><b>What was the industry problem?</b></p>
        <p>Simplifying the delivery & accessibility of waterway health information.</p>
        <p><b>How does Ecohealth address the problem?</b></p>
        <p>The Ecosystem Health Monitoring Program (Ecohealth) is a comprehensive estuarine and freshwater monitoring
          program that reports on the health of our waterways.</p>
        <p>Scientifically robust, quality-assured data generated by Ecohealth gives a complete picture of the current
          state of waterways, connecting the condition of upstream freshwater reaches with the condition of estuaries.
        </p>
        <p><b>How is data science applied?</b></p>
        <p>This interactive web-based tool allows users to select the areas of interest, visualise the data with
          the option to upload collection data by members of the public facilitating collaboration/information
          sharing between the public and the scientists.</p>
        <br>
        <p>Ecohealth has been developed by CASI as part of a research project funded by Hornsby & Coffs Harbour
          Councils.
        </p>
      </div>

      <!-- <div class="col-xs-12" style="text-align: right;">
      <a  style="color: inherit;"><i class="fa fa-chevron-up fa-2x" ng-(click)="vm.backToTop()"></i></a>
      <hr style="border-top: 2px solid;">
    </div> -->
    </div>
  </div>
  }
  @case("enrichinglivestock"){
  <div id="enrichinglivestock" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/eal_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Understanding the impact of various enrichments on animal welfare for
          intensively
          housed livestock species.</p>
        <p class="largetext light-font">
          Visit <a href="https://enrichinglivestock.une.edu.au" target="_blank" class="altlink"> Enriching Australian
            Livestock</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/eal_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://enrichinglivestock.une.edu.au" target="_blank">
            <img src="../../assets/images/eal_logo.jpg" style="margin: 0px 0px 40px -30px; height: 150px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://enrichinglivestock.une.edu.au" target="_blank">
            <img src="../../assets/images/eal_logo.jpg" style="margin: 0px 0px 30px -30px; height: 150px;"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://enrichinglivestock.une.edu.au" target="_blank">
            <img src="../../assets/images/eal_logo.jpg" style="margin: 0px 0px 30px -30px; height: 100px;"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to disseminate credible information on the impact of enrichments on the lives of intensively
          housed livestock species on animal welfare.</p>
        <p>These include: meat chickens, laying hens, pigs, cattle and sheep across Australian livestock and
          food production sectors.</p>
        <p><b>How does Enriching Australian Livestock address the problem?</b></p>
        <p>There is potential to improve the welfare of livestock exponentially by providing graziers,
          hobby farmers and animal owners a web-based tool, enabling them to easily find and interpret
          scientific publications dealing with enrichments for intensively farmed animals.</p>
        <p>Enriching Australian Livestock provides access to a peer reviewed knowledge-base of scientific
          results through a set of easy-to-use, searchable dashboards for each species, sharing advice on
          the effects of specific enrichments to achieve desired health, welfare and production outcomes.</p>
        <p>Publications are summarised, allowing for the easy discovery of positive, neutral and negative impacts for
          specific enrichments.</p>
        <p><b>How is data science applied?</b></p>
        <p>Simplifying access to multiple scientific publications and summarising what impact specific
          interventions will have on the physical and mental health, expression of natural behaviour and
          productivity of animals.</p>
        <br>
        <p>Enriching Australian Livestock was developed by CASI as part of a research collaboration led by the
          University
          of New England and funded by the National Animal Welfare RD&E Strategy.</p>
      </div>

      <!-- <div class="col-xs-12" style="text-align: right;">
      <a  style="color: inherit;"><i class="fa fa-chevron-up fa-2x" ng-(click)="vm.backToTop()"></i></a>
      <hr style="border-top: 2px solid;">
    </div> -->
    </div>
  </div>
  }
  @case("ldlinsights"){
  <div id="ldlinsights" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/ldl_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">The Livestock Data Link project provides a solution to deliver insights from
          previously
          inaccessible industry databases used to improve management and genetic outcomes in their enterprises.</p>
        <p class="largetext light-font">
          This site is currently not available. Demonstrations can be scheduled as required.
          <!-- Visit <a href="https://ldlinsights-uat.une.edu.au" target="_blank" class="altlink"> LDL Insights</a> -->
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/ldl_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <img src="../../assets/images/ldl_logo.png" style="margin: 40px 0; width: 200px;">
        </div>
        <div class="col-sm-12 no-padding d-none d-sm-block">
          <img src="../../assets/images/ldl_logo.png" style="margin: 30px 0; width:200px">
          <!-- <a href="https://ldlinsights-uat.une.edu.au" target="_blank">
          <img src="../../assets/images/ldl_logo.png" style="margin: 30px 0; width:200px"></a> -->
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <img src="../../assets/images/ldl_logo.png" style="margin: 30px 0; width:120px">
          <!-- <a href="https://ldlinsights-uat.une.edu.au" target="_blank">
          <img src="../../assets/images/ldl_logo.png" style="margin: 30px 0; width:120px"></a> -->
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to deliver value from industry data up and down the supply chain? Meat and Livestock Australia (MLA) is
          the
          custodian of large industry datasets that can provide significant value to breeders, producers and processors.
          The challenge is to enable the flow of useful information to the relevant industry players to deliver
          actionable
          insights.</p>
        <p><b>How does Livestock Data Link (insights) address the problem?</b></p>
        <p>Livestock Data Link uses data from Australian sheep and cattle databases in the MLA Group Data Platform, to
          build 32
          functional web-based concept dashboards that allow breeders, producers and processors to compare their
          production
          against their shire, region, state & nationally.</p>
        <p>The enhanced dashboards allow for the visualisation of carcase and health data in both time, and trait x
          trait
          dimensions comparing properties, shires, regions, state and national to provide comparative analysis of trends
          and
          performance.</p>
        <p>Trialling several concept dashboards, allowing key stakeholders to compare their performance with others on a
          regional,
          state and national level will enabled them to rank the useability and importance each dashboard for
          integration
          in MLA
          solutions.</p>
        <p><b>How is data science applied?</b></p>
        <p>Developing models and visualisations that provide new insights and value to carcase and health data stored in
          industry
          databases, is key to enabling producers and processors to identify areas for improvement in their operations.
          Trialling several concept dashboards with key industry stakeholders, enabled them to rank the usability and
          importance
          each dashboard, delivered a development roadmap to integrate these in MLA systems.</p>
        <br>
        <p>Livestock Data Link Prototype Dashboard was developed by CASI for Integrity Systems Company for the
          Australian
          red-meat industry.</p>
      </div>

      <!-- <div class="col-xs-12" style="text-align: right;">
      <a  style="color: inherit;"><i class="fa fa-chevron-up fa-2x" ng-(click)="vm.backToTop()"></i></a>
      <hr style="border-top: 2px solid;">
    </div> -->
    </div>
  </div>
  }
  @case("worm"){
  <div id="worm" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/worm_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Turned Worm is a web-based tool that will enable advisors, producers,
          researchers
          and
          agriculture students to explore the impact of various worm control strategies.</p>
        <p class="largetext light-font">
          Visit <a href="https://turnedworm.une.edu.au" target="_blank" class="altlink"> Turned Worm</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/worm_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://turnedworm.une.edu.au" target="_blank">
            <img src="../../assets/images/worm-logo.png" style="margin: 40px 0; width: 300px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://turnedworm.une.edu.au" target="_blank">
            <img src="../../assets/images/worm-logo.png" style="margin: 30px 0; width:250px"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://turnedworm.une.edu.au" target="_blank">
            <img src="../../assets/images/worm-logo.png" style="margin: 30px 0; width:140px"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Control of internal parasites (worms and nematodes) in Australia is costing ~$529 million per year.
          Mitigating this risk has become more complex as the prevalence and severity of drench resistance has
          increased.
          In response, integrated control options have been developed including grazing management.</p>
        <p>Applying these options can be complicated and requires careful planning to ensure they don’t intentionally
          worsen drench resistance.</p>
        <p><b>How does Turned Worm address the problem?</b></p>
        <p>Dr Yan Laurenson developed a farm specific integrated biophysical model, to simulate the full life cycle of
          the
          four
          prevalent intestinal worm and nematode species in Australia found in sheep. Validation of the model were done
          in
          Victoria and NSW under different climatic conditions. The model predicts pasture worm and larvae burdens,
          adult worm populations in animals, drench resistance and the production and financial consequences from a
          combination
          of worm control options.</p>
        <p>Turned Worm is an online, web-based tool for producers and advisors who want to improve worm control in sheep
          flocks.</p>
        <p><b>How is data science applied?</b></p>
        <p>Simplifying the complex and complicated input required for a comprehensive biophysical model including
          multi-dimensional
          weather data deliver, the benefits of the model to a diverse group of users who can benefit from integrated
          control options.
          Extensive use of graphical visualisations makes it easy to explore the impact of different control strategies
          on
          farm.</p>
        <br>
        <p>Turned Worm was developed by CASI as part of a research project (B.AHE.0308) led by the University of New
          England and funded by Meat and Livestock Australia.</p>
      </div>

    </div>
  </div>
  }
  @case("adri"){
  <div id="adri" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">

      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/ADRI_Circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">The Australian Disaster
          Resilience Index is a snapshot
          of the capacities for disaster
          resilience in Australian
          communities. Understanding
          these capacities, and how
          they differ from place to
          place, will help communities,
          governments and industry
          work together to cope with and
          adapt to natural hazards such
          as bushfires, floods, storms and
          earthquakes.</p>
        <p class="largetext light-font">
          Visit <a href="https://adri.bnhcrc.com.au" target="_blank" class="altlink"> Australian Disaster Resilience
            Index</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px">
        <img src="../../assets/images/ADRI_Circle.png" style="width: 120px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://adri.bnhcrc.com.au" target="_blank">
            <img src="../../assets/images/ADRI_Logo.png"
              style="margin-bottom: 40px; margin-top: 20px; width: 320px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://adri.bnhcrc.com.au" target="_blank">
            <img src="../../assets/images/ADRI_Logo.png" style="margin: 30px 0; width:250px"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://adri.bnhcrc.com.au" target="_blank">
            <img src="../../assets/images/ADRI_Logo.png" style="margin: 30px 0; width:140px"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Simplifying the delivery of the Australian Disaster Resilience Index, and contributing factors to relevant
          stakeholders.</p>
        <p><b>How does Australian Disaster Resilience Index address the problem?</b></p>
        <p></p>
        <p>The Australian Disaster Resilience Index is a snapshot of the capacities for disaster resilience in
          Australian communities. Understanding these capacities, and how they differ from place to place,
          will help communities, governments and industry work together to cope with and adapt to natural hazards
          such as bushfires, floods, storms and earthquakes.</p>
        <p>The Index is useful for the general public, business and industry, not for profit organisations,
          fire and emergency service agents and Local, State and Federal Governments for business development,
          strategic and emergency planning, risk assessment, urban and community planning, regional development
          and further research and modeling.</p>
        <p>Information on 2,084 SA2 (Statistical Area Level 2, Australian Bureau of Statistics) areas around
          Australia is available. This interactive website allows users to select only the areas around Australia
          that is relevant to them, greatly simplifying the process of getting the relevant information.</p>
        <p><b>How is data science applied?</b></p>
        <p>This interactive web-based tool allow users to select the areas of interest, build custom reports and
          visualise the data to make the Index accessible to a large and diverse user base.</p>
        <br>
        <p>The Australian Disaster Resilience Index system has been developed by CASI for the Bushfire and Natural
          Hazards
          CRC.</p>
        <div class="videobanner d-block d-sm-none d-md-block">
          <h3>Australian Disaster Resilience Index User Tutorial</h3>
        </div>
        <iframe src-on-load="redirect()" class=" d-block d-xs-none d-sm-none d-md-block"
          style="height: 470px; width: 100%; margin-bottom: 20px;" src="https://www.youtube.com/embed/YXiGE0EIXnU"
          frameborder="0" gesture="media" allowfullscreen></iframe>
        <iframe src-on-load="redirect()" class="d-none d-xs-block d-sm-none"
          style="width: 100%;  height: 70vw; margin-bottom: 20px;" src="https://www.youtube.com/embed/YXiGE0EIXnU"
          frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>
      <div class="col-sm-12 d-none d-sm-block d-md-none">
        <div class="videobanner">
          <h3>Australian Disaster Resilience Index User Tutorial</h3>
        </div>
        <iframe src-on-load="redirect()" style="width: 100%;  height: 80vw; margin-bottom: 20px;"
          src="https://www.youtube.com/embed/YXiGE0EIXnU" frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>

    </div>
  </div>
  }
  @case("ag360"){
  <div id="ag360" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">

      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/Ag360_Circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Record farm management
          as well as predicting rainfall,
          soil moisture, pasture growth,
          animal weight and health risks
          up to 6 months in advance.
          Predictions based on powerful,
          accurate scientific models that
          draw on all the expertise at the
          University of New England.</p>
        <p class="largetext light-font">
          Visit <a href="https://ag360.com.au" target="_blank" class="altlink"> Ag360</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px">
        <img src="../../assets/images/Ag360_Circle.png" style="width: 120px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://ag360.com.au" target="_blank">
            <img src="../../assets/images/Ag360_Logo.png" style="margin-bottom: 40px; margin-top: 20px; width: 320px;">
          </a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://ag360.com.au" target="_blank">
            <img src="../../assets/images/Ag360_Logo.png" style="margin: 30px 0; width:250px">
          </a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://ag360.com.au" target="_blank">
            <img src="../../assets/images/Ag360_Logo.png" style="margin: 30px 0; width:140px">
          </a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Using farm records to deliver seasonal predictions assisting Australian graziers to make strategic and
          management decisions that improve livestock welfare, minimise production losses and improve their economic
          outcomes.</p>
        <p><b>How does Ag360 address the problem?</b></p>
        <p>Ag360 is a web-based tool that allows graziers to capture the farm records and provide 90 to 180 day
          forecasts for individual properties on rainfall, pasture availability, soil moisture, and animal growth
          and health risks. Ag360 is a replacement for ASKBILL with an improved user interface as well as growth
          models for cattle.</p>
        <p><b>How is data science applied?</b></p>
        <p>Driving Ag360 predictions is an extensive weather database holding interpolated weather observations,
          deterministic as well as probabilistic (seasonal) forecasts. This is combined with farm records comprising
          of management, genetic, treatment, feeding information and local rainfall observations to feed analytical
          and statistical models.</p>
        <p>Probabilistic forecasts is visualised in such a way to provide users with a range of possible outcomes
          that can be used for planning, tactical and strategic decision making.</p>
        <br>
        <p>Ag360 has been developed by CASI for Ag360 Pty Ltd.</p>
        <div class="videobanner d-block d-sm-none d-md-block">
          <h3>Ag360 User Tutorial</h3>
        </div>
        <iframe src-on-load="redirect()" class=" d-block d-xs-none d-sm-none d-md-block"
          style="height: 470px; width: 100%; margin-bottom: 20px;" src="https://www.youtube.com/embed/fdYWBA87iJ4"
          frameborder="0" gesture="media" allowfullscreen></iframe>
        <iframe src-on-load="redirect()" class="d-none d-xs-block d-sm-none"
          style="width: 100%;  height: 70vw; margin-bottom: 20px;" src="https://www.youtube.com/embed/fdYWBA87iJ4"
          frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>
      <div class="col-sm-12 d-none d-sm-block d-md-none">
        <div class="videobanner">
          <h3>Ag360 User Tutorial</h3>
        </div>
        <iframe src-on-load="redirect()" style="width: 100%;  height: 80vw; margin-bottom: 20px;"
          src="https://www.youtube.com/embed/fdYWBA87iJ4" frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>

    </div>
  </div>
  }
  @case("ag360education"){
  <div id="ag360education" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/Ag360_Circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Record farm management
          as well as predicting rainfall,
          soil moisture, pasture growth,
          animal weight and health risks
          up to 6 months in advance.
          Predictions based on powerful,
          accurate scientific models that
          draw on all the expertise at the
          University of New England.</p>
        <p class="largetext light-font">
          Visit <a href="https://ag360-education.une.edu.au" target="_blank" class="altlink"> Ag360 Education</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px">
        <img src="../../assets/images/Ag360_Circle.png" style="width: 120px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://ag360-education.une.edu.au" target="_blank">
            <img src="../../assets/images/Ag_360_Education_Logo.png"
              style="margin-bottom: 40px; margin-top: 20px; width: 320px;">
          </a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://ag360-education.une.edu.au" target="_blank">
            <img src="../../assets/images/Ag_360_Education_Logo.png" style="margin: 30px 0; width:250px">
          </a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://ag360-education.une.edu.au" target="_blank">
            <img src="../../assets/images/Ag_360_Education_Logo.png" style="margin: 30px 0; width:140px">
          </a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Using farm records to deliver seasonal predictions assisting Australian graziers to make strategic and
          management decisions that improve livestock welfare, minimise production losses and improve their economic
          outcomes.</p>
        <p><b>How does Ag360 address the problem?</b></p>
        <p>Ag360 is a web-based tool that allows graziers to capture the farm records and provide 90 to 180 day
          forecasts for individual properties on rainfall, pasture availability, soil moisture, and animal growth
          and health risks. Ag360 is a replacement for ASKBILL with an improved user interface as well as growth
          models for cattle.</p>
        <p><b>How is data science applied?</b></p>
        <p>Driving Ag360 predictions is an extensive weather database holding interpolated weather observations,
          deterministic as well as probabilistic (seasonal) forecasts. This is combined with farm records comprising
          of management, genetic, treatment, feeding information and local rainfall observations to feed analytical
          and statistical models.</p>
        <p>Probabilistic forecasts is visualised in such a way to provide users with a range of possible outcomes
          that can be used for planning, tactical and strategic decision making.</p>
        <br>
        <p>Ag360 has been developed by CASI for Ag360 Pty Ltd.</p>
        <div class="videobanner d-block d-sm-none d-md-block">
          <h3>Ag360 User Tutorial</h3>
        </div>
        <iframe src-on-load="redirect()" class=" d-block d-xs-none d-sm-none d-md-block"
          style="height: 470px; width: 100%; margin-bottom: 20px;" src="https://www.youtube.com/embed/fdYWBA87iJ4"
          frameborder="0" gesture="media" allowfullscreen></iframe>
        <iframe src-on-load="redirect()" class="d-none d-xs-block d-sm-none"
          style="width: 100%;  height: 70vw; margin-bottom: 20px;" src="https://www.youtube.com/embed/fdYWBA87iJ4"
          frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>
      <div class="col-sm-12 d-none d-sm-block d-md-none">
        <div class="videobanner">
          <h3>Ag360 User Tutorial</h3>
        </div>
        <iframe src-on-load="redirect()" style="width: 100%;  height: 80vw; margin-bottom: 20px;"
          src="https://www.youtube.com/embed/fdYWBA87iJ4" frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>

    </div>
  </div>
  }
  @case("mobselect"){
  <div id="mobselect" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/mobselect_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">MobSelect is an easy-to-use dashboard and selection tool that assists red meat
          producers and value chain partners to optimise supply of livestock.</p>
        <p class="largetext light-font">
          This site is currently not available. Demonstrations can be scheduled as required.
          <!-- Visit <a href="https://sheepcrc-ampc-une-dev.une.edu.au" target="_blank" class="altlink"> MobSelect</a> -->
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/mobselect_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <img src="../../assets/images/mobselect_logo.png" style="margin-bottom: 40px; width: 250px;">
          <!-- <a href="https://sheepcrc-ampc-une-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/mobselect_logo.png" style="margin-bottom: 40px; width: 250px;"></a> -->
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <img src="../../assets/images/mobselect_logo.png" style="margin-bottom: 30px; width:250px">
          <!-- <a href="https://sheepcrc-ampc-une-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/mobselect_logo.png" style="margin-bottom: 30px; width:250px"></a> -->
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <img src="../../assets/images/mobselect_logo.png" style="margin-bottom: 30px; width:140px">
          <!-- <a href="https://ssheepcrc-ampc-une-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/mobselect_logo.png" style="margin-bottom: 30px; width:140px"></a> -->
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to assist red meat processors, stock and station agents and buyers to schedule purchasing decisions
          to optimise logistics.</p>
        <p><b>How does MobSelect address the problem?</b></p>
        <p>MobSelect enables red meat producers to share information from Ag360 on predicted liveweight and carcass
          performance with processors and other value chain partners. This information is aggregated in a dashboard
          to allow purchasers to select mobs based on weight, availability, breed, health and welfare criteria.</p>
        <p><b>How is data science applied?</b></p>
        <p>Using models that utilise weather forecasts, animal management and genetics, Ag360 predicts growth and
          distributions of mobs up to 180 days into the future. MobSelect aggregates this information in a single
          dashboard and provides selection tools to identify relevant mobs that meet the selection criteria.</p>
        <br>
        <p>MobSelect was developed by CASI and as currently in a trial phase with project partners JBS Australia
          and the Australian Meat Processing Corporation.</p>
      </div>

    </div>
  </div>
  }
  @case("sugarmaps"){
  <div id="sugarmaps" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/sugarmaps_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Improved data access, yield forecasting and targeted nitrogen application
          for the Australian Sugar industry.</p>
        <p class="largetext light-font">
          This site is currently not available. Demonstrations can be scheduled as required.
          <!-- Visit <a href="https://sugarmap-une-dev.une.edu.au" target="_blank" class="altlink"> SugarMaps</a> -->
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/sugarmaps_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <img src="../../assets/images/sugarmaps_logo.png" style="margin: 40px 0; width: 320px;">
          <!-- <a href="https://sugarmap-une-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/sugarmaps_logo.png" style="margin: 40px 0; width: 320px;"></a> -->
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <img src="../../assets/images/sugarmaps_logo.png" style="margin: 30px 0; width:250px">
          <!-- <a href="https://sugarmap-une-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/sugarmaps_logo.png" style="margin: 30px 0; width:250px"></a> -->
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <img src="../../assets/images/sugarmaps_logo.png" style="margin: 30px 0; width:140px">
          <!-- <a href="https://sugarmap-une-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/sugarmaps_logo.png" style="margin: 30px 0; width:140px"></a> -->
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to improve sugar industry in-season yield forecasting and nitrogen management.</p>
        <p><b>How does Sugarmaps address the problem?</b></p>
        <p>Sugarmaps provides automated processing and delivery workflow that brings remotely sensed imagery to
          over 95% of the sugar industry. Products include crop vigour, derived yield and qualitative foliar
          nitrogen concentration maps for most Australian growing regions.</p>
        <p><b>How is data science applied?</b></p>
        <p>Sugarmaps evaluates imagery from the recently launched Sentinel satellite by the European Space Agency (ESA).
          Sentinel 2 satellite imagery is of appropriate resolution for sugarcane monitoring at the block level (10 m)
          and offers spectral bands that are compatible with SPOT 6 imagery, allowing previously developed algorithms
          for yield, vigour and nitrogen to be applied.</p>
        <br>
        <p>Sugarmaps was developed by CASI as part of a University of New England research project and is
          funded by Sugar Research Australia.</p>
      </div>

    </div>
  </div>
  }
  @case("ramselect"){
  <div id="ramselect" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/ramselect_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">RamSelect is designed to simplify the use of Australian Sheep Breeding Values
          (ASBVs)
          to identify the right genetics for your flock using data from Sheep Genetics</p>
        <p class="largetext light-font">
          Visit <a href="https://ramselect.com.au" target="_blank" class="altlink"> RamSelect</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px">
        <img src="../../assets/images/ramselect_circle.png" style="width: 120px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://ramselect.com.au" target="_blank">
            <img src="../../assets/images/RamSelect_Logo.jpg" style="margin: 40px 0;width: 320px;">
          </a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://ramselect.com.au" target="_blank">
            <img src="../../assets/images/RamSelect_Logo.jpg" style="margin: 30px 0; width:250px">
          </a>
        </div>
        <div class="col-md-12 no-padding d-none d-xs-block">
          <a href="https://ramselect.com.au" target="_blank">
            <img src="../../assets/images/RamSelect_Logo.jpg" style="margin: 30px 0; width:140px">
          </a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to improve economic outcomes in the sheep industry through
          genetic improvement of animal herds.</p>
        <p><b>How does RamSelect address the problem?</b></p>
        <p>RamSelect is a tool that simplifies the use of Australian Sheep Breeding
          Values (ASBVs) so that breeders can quickly and easily identify the right
          genetics for their flock.</p>
        <p>RamSelect allows better management of ram teams by comparing ram
          selections with national averages and tracking team performance and
          impact over time.</p>
        <p><b>How is data science applied?</b></p>
        <p>RamSelect is a tool that simplifies the use of Australian Sheep Breeding
          Values (ASBVs) so that breeders can quickly and easily identify the right
          genetics for their flock.</p>
        <p>RamSelect is a powerful decision support tool that removes variation
          caused by environmental and management effects and predicts the
          genetic merit of rams.</p>
        <br>
        <p>RamSelect has been developed by CASI in partnership
          with the Sheep CRC.</p>
      </div>

    </div>
  </div>
  }
  @case("ramselecttraining"){
  <div id="ramselecttraining" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/ramselect_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">RamSelect is designed to simplify the use of Australian Sheep Breeding Values
          (ASBVs)
          to identify the right genetics for your flock using data from Sheep Genetics</p>
        <p class="largetext light-font">
          Visit <a href="https://ramselect-training.une.edu.au" target="_blank" class="altlink"> RamSelect Training</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px">
        <img src="../../assets/images/ramselect_circle.png" style="width: 120px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://ramselect-training.une.edu.au" target="_blank">
            <img src="../../assets/images/RamSelect_Training_Logo.png" style="margin: 40px 0;width: 320px;">
          </a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://ramselect-training.une.edu.au" target="_blank">
            <img src="../../assets/images/RamSelect_Training_Logo.png" style="margin: 30px 0; width:250px">
          </a>
        </div>
        <div class="col-md-12 no-padding d-none d-xs-block">
          <a href="https://ramselect-training.une.edu.au" target="_blank">
            <img src="../../assets/images/RamSelect_Training_Logo.png" style="margin: 30px 0; width:140px">
          </a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to improve economic outcomes in the sheep industry through
          genetic improvement of animal herds.</p>
        <p><b>How does RamSelect address the problem?</b></p>
        <p>RamSelect is a tool that simplifies the use of Australian Sheep Breeding
          Values (ASBVs) so that breeders can quickly and easily identify the right
          genetics for their flock.</p>
        <p>RamSelect allows better management of ram teams by comparing ram
          selections with national averages and tracking team performance and
          impact over time.</p>
        <p><b>How is data science applied?</b></p>
        <p>RamSelect is a tool that simplifies the use of Australian Sheep Breeding
          Values (ASBVs) so that breeders can quickly and easily identify the right
          genetics for their flock.</p>
        <p>RamSelect is a powerful decision support tool that removes variation
          caused by environmental and management effects and predicts the
          genetic merit of rams.</p>
        <br>
        <p>RamSelect has been developed by CASI in partnership
          with the Sheep CRC.</p>
      </div>

    </div>
  </div>
  }
  @case("sheepdna"){
  <div id="sheepdna" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/sheepdna_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Test drive genetic gain in the sheep industry by increasing the accuracy of
          ASBVs,
          providing accurate pedigree and genetic benchmarking of commercial flocks.</p>
        <p class="largetext light-font">
          Visit <a href="https://sheepdna.com.au" target="_blank" class="altlink"> SheepDNA</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/sheepdna_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://sheepdna.com.au" target="_blank">
            <img src="../../assets/images/sheepdna_logo.png" style="margin: 40px 0; width: 320px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://sheepdna.com.au" target="_blank">
            <img src="../../assets/images/sheepdna_logo.png" style="margin: 30px 0; width:250px"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://sheepdna.com.au" target="_blank">
            <img src="../../assets/images/sheepdna_logo.png" style="margin: 30px 0; width:140px"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Determining the genetic merit and parentage of sheep at a young age to guide selection and breeding
          decisions.
        </p>
        <p><b>How does SHEEPDNA address the problem?</b></p>
        <p>SHEEPDNA increases the accuracy of Australian Sheep Breeding Values (ASBVs) by providing breeders with
          functionality to order genomic, parentage and poll tests. Commercial producers can determine the average
          genetic merit of their flocks through flock profile tests.</p>
        <p><b>How is data science applied?</b></p>
        <p>Genomics is a fast and reliable way to read the genetic code that determines sheep performance.
          The SHEEPDNA service streamlines the ordering and handling of genomic tests and workflow.</p>
        <br>
        <p>SHEEPDNA has been developed by CASI with testing services provided by Neogen Australasia.</p>
      </div>

    </div>
  </div>
  }
  @case("labreport"){
  <div id="labreport" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/labreport_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Innovation in Biosecurity Detector Dog Operations.</p>
        <p class="largetext light-font">
          This site is currently not available. Demonstrations can be scheduled as required.
          <!-- Visit <a href="https://labreport-dev.une.edu.au" target="_blank" class="altlink"> LabReport</a> -->
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/labreport_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <img src="../../assets/images/labreport_logo.png" style="margin-bottom: 40px; width: 370px;">
          <!-- <a href="https://labreport-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/labreport_logo.png" style="margin-bottom: 40px; width: 370px;"></a> -->
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <img src="../../assets/images/labreport_logo.png" style="margin-bottom: 30px; width:250px">
          <!-- <a href="https://labreport-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/labreport_logo.png" style="margin-bottom: 30px; width:250px"></a> -->
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <img src="../../assets/images/labreport_logo.png" style="margin-bottom: 30px; width:140px">
          <!-- <a href="https://labreport-dev.une.edu.au" target="_blank">
          <img src="../../assets/images/labreport_logo.png" style="margin-bottom: 30px; width:140px"></a> -->
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to improve biosecurity detector dog welfare and utilisation.</p>
        <p><b>How does LabReport address the problem?</b></p>
        <p>LabReport facilitates the accurate and efficient collection of dog performance and management data that can
          be used to improve biosecurity detector dog welfare and utilisation.</p>
        <p><b>How is data science applied?</b></p>
        <p>LabReport provide dog handlers, supervisors, section managers and researchers with a centralised tool in
          which all aspects of dog management, training, work schedules and detections made documented.
          Data collected will be analysed as part of on-going research to understand and improve the efficiency of
          working dogs.</p>
        <br>
        <p>LabReport was developed by CASI as part of a collaborative research project between the
          University of New England and the Australian Department of Agriculture.</p>
      </div>

    </div>
  </div>
  }
  @case("hens"){
  <div id="hens" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/hens_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Understanding the impact of hen movement on body weight in an
          open aviary system.</p>
        <p class="largetext light-font">
          This site is currently not available. Demonstrations can be scheduled as required.
          <!-- Visit <a href="https://visualhens.une.edu.au" target="_blank" class="altlink"> Visual Hens</a> -->
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/hens_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <img src="../../assets/images/hens_logo.png" style="margin-bottom: 40px; height: 90px;">
          <!-- <a href="https://visualhens.une.edu.au" target="_blank">
            <img src="../../assets/images/hens_logo.png" style="margin-bottom: 40px; height: 90px;"></a> -->
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <img src="../../assets/images/hens_logo.png" style="margin-bottom: 30px; width:250px">
          <!-- <a href="https://visualhens.une.edu.au" target="_blank">
            <img src="../../assets/images/hens_logo.png" style="margin-bottom: 30px; width:250px"></a> -->
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <img src="../../assets/images/hens_logo.png" style="margin-bottom: 30px; width:140px">
          <!-- <a href="https://visualhens.une.edu.au target="_blank">
            <img src="../../assets/images/hens_logo.png" style="margin-bottom: 30px; width:140px"></a> -->
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to understand the impact of hen movement on body weight in an open aviary system.</p>
        <p><b>How does Visual Hens address the problem?</b></p>
        <p>Visual Hens allows you to generate information about and understand flock location for the duration of the
          entire laying period including the load of resources (nest boxes, feeder lines, range) and flock movement
          during the light period of a day.</p>
        <p><b>How is data science applied?</b></p>
        <p>Visual Hens uses RFID data to track the movement of hens within an aviary.
          Information is generated using interactive visualisation tools.</p>
        <br>
        <p>Visual Hens was developed by CASI for Australian Eggs.</p>
      </div>

    </div>
  </div>
  }
  @case("askbill"){
  <div id="askbill" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/askbill_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Accurate predictions of sheep wellbeing and productivity using weather,
          stock and pasture information across Australia</p>
        <p class="largetext light-font">
          Visit <a href="https://askbill.com.au" target="_blank" class="altlink"> ASKBILL</a>
          <br>
          Or <a href="https://askbill-training.une.edu.au" target="_blank" class="altlink"> ASKBILL Training</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px">
        <img src="../../assets/images/askbill_circle.png" style="width: 120px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://askbill.com.au" target="_blank">
            <img src="../../assets/images/AskBill_Logo.png"
              style="margin-bottom: 40px; margin-top: 20px; width: 320px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://askbill.com.au" target="_blank">
            <img src="../../assets/images/AskBill_Logo.png" style="margin: 30px 0; width:250px"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://askbill.com.au" target="_blank">
            <img src="../../assets/images/AskBill_Logo.png" style="margin: 30px 0; width:140px"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to enhance animal wellbeing and minimise production losses to improve economic outcomes in the sheep
          industry.</p>
        <p><b>How does ASKBILL address the problem?</b></p>
        <p>ASKBILL is a tool that provides current and 90-day forecasts customised for individual properties using
          climate, stock and pasture information.</p>
        <p><b>How is data science applied?</b></p>
        <p>ASKBILL brings together farm data, weather data and industry knowledge to inform analytical models that
          predict
          pasture growth, animal performance, flystrike, worm infection and weather stress at the mob and individual
          sheep
          level.</p>
        <p>ASKBILL utilises complex statistical modelling and prediction routines developed by researchers and the CASI
          team.</p>
        <br>
        <p>ASKBILL has been developed by CASI in partnership with the Sheep CRC.</p>
        <div class="videobanner hidden-sm">
          <h3>ASKBILL explained in under three minutes</h3>
        </div>
        <iframe src-on-load="redirect()" class=" d-block d-xs-none d-sm-none"
          style="height: 300px; width: 80%; margin-bottom: 20px;" src="https://www.youtube.com/embed/dHa1rgKNclc"
          frameborder="0" gesture="media" allowfullscreen></iframe>
        <iframe src-on-load="redirect()" class="d-none d-xs-block"
          style="width: 100%;  height: 70vw; margin-bottom: 20px;" src="https://www.youtube.com/embed/dHa1rgKNclc"
          frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>
      <div class="col-sm-12 visible-sm">
        <div class="videobanner">
          <h3>ASKBILL explained in under three minutes</h3>
        </div>
        <iframe src-on-load="redirect()" style="width: 100%;  height: 80vw; margin-bottom: 20px;"
          src="https://www.youtube.com/embed/dHa1rgKNclc" frameborder="0" gesture="media" allowfullscreen></iframe>
      </div>

    </div>
  </div>
  }
  @case("lagoons"){
  <div id="lagoons" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/lagoons_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">Building knowledge and public support to secure threatened Upland Wetlands
          on the Northern Tablelands.</p>
        <p class="largetext light-font">
          This site is currently not available. Demonstrations can be scheduled as required.
          <!-- Visit <a href="https://dynamiclagoons.une.edu.au" target="_blank" class="altlink"> Dynamic Lagoons</a> -->
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/lagoons_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <img src="../../assets/images/lagoons_logo.png" style="margin: 40px 0; width: 250px;">
          <!-- <a href="https://dynamiclagoons.une.edu.au" target="_blank">
            <img src="../../assets/images/lagoons_logo.png" style="margin: 40px 0; width: 250px;"></a> -->
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <img src="../../assets/images/lagoons_logo.png" style="margin: 30px 0; width:250px">
          <!-- <a href="https://dynamiclagoons.une.edu.au" target="_blank">
            <img src="../../assets/images/lagoons_logo.png" style="margin: 30px 0; width:250px"></a> -->
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <img src="../../assets/images/lagoons_logo.png" style="margin: 30px 0; width:140px">
          <!-- <a href="https://dynamiclagoons.une.edu.au" target="_blank">
            <img src="../../assets/images/lagoons_logo.png" style="margin: 30px 0; width:140px"></a> -->
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to build knowledge on the benefits of Upland Wetlands on the Northern Tablelands.</p>
        <p><b>How does Dynamic Lagoons address the problem?</b></p>
        <p>Dynamic Lagoons is an evidence-based public engagement and education program to raise awareness
          of the importance of wet-dry phenologies in Upland Wetlands. It uses restoration experiments and
          ecological monitoring to increase knowledge of the wetlands.</p>
        <p><b>How is data science applied?</b></p>
        <p>Dynamic Lagoons is a citizen science project that enables collection of data by members of the
          public and collaboration/information sharing between the public and scientists.</p>
        <br>
        <p>Dynamic Lagoons was developed by CASI as part of a University of New England research project.</p>
      </div>

    </div>
  </div>
  }
  @case("herbarium"){
  <div id="herbarium" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">
      <div class="col-md-3 col-sm-3  d-block d-xs-none">
        <img src="../../assets/images/herb_circle.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">N.C.W Beadle Herbarium Collection Manager is an easy-to-use web-based
          tool that enables the storage & discovery of high-quality collections of preserved plant specimens.</p>
        <p class="largetext light-font">
          Visit <a href="https://ncw-beadleherbarium.une.edu.au" target="_blank" class="altlink"> N.C.W Beadle
            Herbarium</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/herb_circle.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding  d-block d-xs-none d-sm-none">
          <a href="https://ncw-beadleherbarium.une.edu.au" target="_blank">
            <img src="../../assets/images/herb_logo.png" style="margin: 40px 0; height: 90px;"></a>
        </div>
        <div class="col-sm-12 no-padding visible-sm">
          <a href="https://ncw-beadleherbarium.une.edu.au" target="_blank">
            <img src="../../assets/images/herb_logo.png" style="margin: 30px 0; height: 90px;"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://ncw-beadleherbarium.une.edu.au" target="_blank">
            <img src="../../assets/images/herb_logo.png" style="margin: 30px 0; width:240px"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>How to equip taxonomists, ecologists & students with a tool to curate high-quality collections of
          preserved plant specimens in a well-managed, web-based secure environment, assisting with student
          education, and to document the world’s flora to provide a constant and permanent record of botanical
          diversity.</p>
        <p><b>How does N.C.W. Beadle Herbarium Collection Manager address the problem?</b></p>
        <p>The NCW Beadle Herbarium Collection Manager fulfils the curation, research and teaching needs and
          contributes to UNE’s commitment to flexible teaching, research excellence, and openness to the community.
          The system allows the Herbarium to undertake teaching, research, reference and identification of specimens.
          It serves University staff, researchers, ecologists, students and the public, and collaborates with
          herbaria worldwide.</p>
        <p>This role is increasingly important as the rate of habitat destruction increases and climate change
          precipitates rapid changes in species' ranges and all aspects of their ecology.</p>
        <p><b>How is data science applied?</b></p>
        <p>This interactive web-based tool allows users to capture specimen information for inclusion to the
          herbarium collections, with advanced search capabilities available to review specimens in various
          geographical areas, specimen types of interest and is accessible to a large and diverse user base.</p>
        <p>Spatial, image and document handling capabilities are integrated and a dedicated permits and permissions
          functionality make it easy to meet the requirements of the Nagoya protocol.</p>
        <br>
        <p>N.C.W. Beadle Herbarium Collection Manager was developed by CASI for the University of New England.</p>
      </div>

    </div>
  </div>
  }
  @default{
  <div id="environer" class="col-md-12 col-xs-12" style="padding: 60px 0px;">
    <div class="row">

      <div class="col-md-3 col-sm-3 d-block d-xs-none">
        <img src="../../assets/images/env_img.png" style="width: 100%; max-width: 500px;">
        <p class="largetext light-font">The Environer project provides a free independent online decision support
          tool for farmers, fishers and foresters who want to learn about managing natural capital, biodiversity,
          and carbon for multiple benefits.</p>
        <p class="largetext light-font">
          Visit <a href="https://environer.une.edu.au" target="_blank" class="altlink"> Environer</a>
        </p>
      </div>
      <div class="col-xs-12 d-none d-xs-block" style="margin-bottom: 20px; padding-left: 40px;">
        <img src="../../assets/images/env_img.png" style="width: 150px;">
      </div>
      <div class="col-md-8 col-sm-9 col-xs-12" style="padding-left: 40px;">
        <div class="col-md-12 no-padding d-block d-xs-none d-sm-none">
          <a href="https://environer.une.edu.au" target="_blank"
            style="background-color: #231f20; display: block; height: 130px; width: 420px; margin-bottom: 40px;">
            <img src="../../assets/images/env_logo.png" style="margin: 0px 0px 40px 0px; height: 130px;"></a>
        </div>
        <div class="col-sm-12 no-padding d-none d-sm-block">
          <a href="https://environer.une.edu.au" target="_blank"
            style="background-color: #231f20; display: block; height: 130px; width: 420px; margin-bottom: 30px;">
            <img src="../../assets/images/env_logo.png" style="margin: 0px 0px 30px 0px; height: 130px;"></a>
        </div>
        <div class="col-xs-12 no-padding d-none d-xs-block">
          <a href="https://environer.une.edu.au" target="_blank"
            style="background-color: #231f20; display: block; height: 100px; width: 330px; margin-bottom: 30px;">
            <img src="../../assets/images/env_logo.png" style="margin: 0px 0px 30px 0px; height: 100px;"></a>
        </div>
        <p><b>What was the industry problem?</b></p>
        <p>Published information on commodity markets and financial products available to Australian primary producers
          in environmental stewardship and sustainability was spread in Australia and overseas but not accessible in
          one place.</p>
        <p><b>How does Environer address the problem?</b></p>
        <p>Environer has been developed by reviewing this information covering the benefits and costs of improving
          natural capital, carbon and biodiversity, including the provision of ecosystem services, social license
          and economic impacts and using it to develop Environer a single entity allowing discovery, opportunity
          and decision tools allowing Australia producers across all industries to make informed decisions about
          the management of carbon and natural capital in production systems</p>
        <p><b>How is data science applied?</b></p>
        <p>Simplifying access to opportunities that provide access to commodity markets and financial products and
          outcomes related to carbon and emission reduction, sustainability and environmental stewardship.</p>
        <br>
        <p>Environer has been developed by CASI, research provided by UNE in partnership with AgriFutures Australia.</p>
      </div>
    </div>

  </div>
  }
  }
  <div class="row">
    <div class="col-xs-12" style="text-align: right;">
      <a style="color: inherit;" (click)="backToTop()"><fa-icon class="fa-solid fa-duotone"
          [icon]="['fad', 'chevron-up']" size="2x"></fa-icon></a>
      <hr style="border-top: 2px solid;">
    </div>
  </div>

</div>
